import { SETTINGS_FEATURE_FLAG, ANGULAR_SETTINGS_ROUTE, SETTINGS_ROUTE_NAME } from './constants/settingsConstants';

const routes = [
  {
    path: '/settings',
    name: SETTINGS_ROUTE_NAME,
    component: () => import(/* webpackChunkName: "SettingsPage" */ './views/SettingsPage.vue'),
    props: { featureFlag: SETTINGS_FEATURE_FLAG, angularRoute: ANGULAR_SETTINGS_ROUTE },
    meta: { i18n: 'settings-pov', pageNameEn: 'Settings' },
  },
];

export default routes;
